let inMemoryToken = null;

export class AuthToken {
  static get() {
    try {
      return inMemoryToken || localStorage.getItem('jwt') || null;
    } catch {
      return inMemoryToken || null;
    }
  }

  static set(token, rememberMe) {
    if (rememberMe) {
      try {
        localStorage.setItem('jwt', token || '');
      } catch {
        inMemoryToken = token;
      }
    } else {
      inMemoryToken = token;
      try {
        localStorage.setItem('jwt', '');
      } catch {
        // storage blocked by browser, token lives in memory only
      }
    }
  }

  static applyFromLocationUrlIfExists() {
    const urlParams = new URLSearchParams(
      window.location.search,
    );
    const authToken = urlParams.get('authToken');

    if (!authToken) {
      return;
    }

    this.set(authToken, true);
    window.history.replaceState(
      {},
      document.title,
      window.location.origin,
    );
  }
}
